// components/AboutFormBuilder/AboutSectionBuilder.jsx
import React from "react";
import {
  Box, Typography, Paper, IconButton, Button, Divider,
  Accordion, AccordionSummary, AccordionDetails
} from "@mui/material";
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  ExpandMore as ExpandMoreIcon,
  Edit as EditIcon
} from "@mui/icons-material";
import AboutFieldBuilder from "./AboutFieldBuilder";

const AboutSectionBuilder = ({ sections, onSectionDelete, onAddField, onFieldDelete, onFieldEdit }) => {
  return (
    <>
      {sections.map((section) => (
        <Box key={section.id} sx={{ mb: 3 }}>
          <Accordion
            defaultExpanded
            sx={{
              border: '1px solid #e2e8f0',
              boxShadow: 'none',
              borderRadius: '8px !important',
              '&:before': { display: 'none' }
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ fontSize: 20 }} />}
              sx={{
                bgcolor: '#fafafa',
                borderRadius: '8px',
                '& .MuiAccordionSummary-content': {
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                <Box>
                  <Typography variant="subtitle1" fontWeight={600} sx={{ fontSize: '0.95rem', color: '#0f172a' }}>
                    {section.title || 'Untitled Section'}
                  </Typography>
                  {section.description && (
                    <Typography variant="caption" color="textSecondary" sx={{ display: 'block' }}>
                      {section.description}
                    </Typography>
                  )}
                </Box>
                <Box sx={{ ml: 'auto', display: 'flex', gap: 1 }}>
                  <Typography variant="caption" sx={{ color: '#64748b', bgcolor: '#f1f5f9', px: 1.5, py: 0.5, borderRadius: 1 }}>
                    {section.fields?.length || 0} Fields
                  </Typography>
                </Box>
              </Box>
            </AccordionSummary>

            <AccordionDetails sx={{ p: 2 }}>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="caption" fontWeight={500} color="#64748b">
                  FIELDS
                </Typography>
                <Box>
                  <Button
                    size="small"
                    startIcon={<AddIcon fontSize="small" />}
                    onClick={() => onAddField(section)}
                    sx={{
                      textTransform: 'none',
                      fontSize: '0.7rem',
                      color: '#6366f1',
                      '&:hover': {
                        bgcolor: 'rgba(99, 102, 241, 0.04)'
                      }
                    }}
                  >
                    Add Field
                  </Button>
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      onSectionDelete(section.id, section.title);
                    }}
                    sx={{
                      border: '1px solid #fee2e2',
                      borderRadius: 1,
                      padding: '4px',
                      ml: 1
                    }}
                  >
                    <DeleteIcon fontSize="small" sx={{ color: '#ef4444', fontSize: '16px' }} />
                  </IconButton>
                </Box>
              </Box>

              <Divider sx={{ mb: 2 }} />

              {section.fields && section.fields.length > 0 ? (
                <Box>
                  {section.fields.map((field, fIdx) => (
                    <AboutFieldBuilder
                      key={field.id || fIdx}
                      field={field}
                      sectionId={section.id}
                      fieldIndex={fIdx}
                      onDelete={onFieldDelete}
                      onEdit={onFieldEdit}
                    />
                  ))}
                </Box>
              ) : (
                <Box sx={{ p: 3, bgcolor: '#f8fafc', borderRadius: '6px', textAlign: 'center' }}>
                  <Typography variant="body2" color="textSecondary">
                    No fields in this section
                  </Typography>
                  <Button
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() => onAddField(section)}
                    sx={{ mt: 1, textTransform: 'none' }}
                  >
                    Add your first field
                  </Button>
                </Box>
              )}
            </AccordionDetails>
          </Accordion>
        </Box>
      ))}
    </>
  );
};

export default AboutSectionBuilder;